module.exports = "/assets/d7afdaf2f00bbb629070aa371f4f2614.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JT.png
// module id = 1522
// module chunks = 0